import {GET_MANAGEMENT_START, GET_MANAGEMENT_SUCCESS, GET_MANAGEMENT_ERROR} from "../../types";

export default function management(state, action) {
  switch (action.type) {
    case GET_MANAGEMENT_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_MANAGEMENT_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
  }
}
